const CustomDivider = (props) =>{
  return(
    <>
    <div className="flex w-full">
            <h3 className="font-roboto text-[18px] font-medium mb-6 mt-6 mr-3 w-auto min-w-fit max-w-full">
              {props.name}
            </h3>
            <div className="border-t border-gray-500 mt-10 w-full my-4"></div>
            </div>
    </>
  )
}

export default CustomDivider